module.exports = {
	"_from": "websocket@^1.0.25",
	"_id": "websocket@1.0.28",
	"_inBundle": false,
	"_integrity": "sha512-00y/20/80P7H4bCYkzuuvvfDvh+dgtXi5kzDf3UcZwN6boTYaKvsrtZ5lIYm1Gsg48siMErd9M4zjSYfYFHTrA==",
	"_location": "/websocket",
	"_phantomChildren": {},
	"_requested": {
		"type": "range",
		"registry": true,
		"raw": "websocket@^1.0.25",
		"name": "websocket",
		"escapedName": "websocket",
		"rawSpec": "^1.0.25",
		"saveSpec": null,
		"fetchSpec": "^1.0.25"
	},
	"_requiredBy": [
		"/@parity/api"
	],
	"_resolved": "https://registry.npmjs.org/websocket/-/websocket-1.0.28.tgz",
	"_shasum": "9e5f6fdc8a3fe01d4422647ef93abdd8d45a78d3",
	"_spec": "websocket@^1.0.25",
	"_where": "/Users/vstavetski/IdeaProjects/dapp-eth-tx-queue/node_modules/@parity/api",
	"author": {
		"name": "Brian McKelvey",
		"email": "theturtle32@gmail.com",
		"url": "https://github.com/theturtle32"
	},
	"browser": "lib/browser.js",
	"bugs": {
		"url": "https://github.com/theturtle32/WebSocket-Node/issues"
	},
	"bundleDependencies": false,
	"config": {
		"verbose": false
	},
	"contributors": [
		{
			"name": "Iñaki Baz Castillo",
			"email": "ibc@aliax.net",
			"url": "http://dev.sipdoc.net"
		}
	],
	"dependencies": {
		"debug": "^2.2.0",
		"nan": "^2.11.0",
		"typedarray-to-buffer": "^3.1.5",
		"yaeti": "^0.0.6"
	},
	"deprecated": false,
	"description": "Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.",
	"devDependencies": {
		"buffer-equal": "^1.0.0",
		"faucet": "^0.0.1",
		"gulp": "git+https://github.com/gulpjs/gulp.git#4.0",
		"gulp-jshint": "^2.0.4",
		"jshint": "^2.0.0",
		"jshint-stylish": "^2.2.1",
		"tape": "^4.9.1"
	},
	"directories": {
		"lib": "./lib"
	},
	"engines": {
		"node": ">=0.10.0"
	},
	"homepage": "https://github.com/theturtle32/WebSocket-Node",
	"keywords": [
		"websocket",
		"websockets",
		"socket",
		"networking",
		"comet",
		"push",
		"RFC-6455",
		"realtime",
		"server",
		"client"
	],
	"license": "Apache-2.0",
	"main": "index",
	"name": "websocket",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/theturtle32/WebSocket-Node.git"
	},
	"scripts": {
		"gulp": "gulp",
		"install": "(node-gyp rebuild 2> builderror.log) || (exit 0)",
		"test": "faucet test/unit"
	},
	"version": "1.0.28"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/websocket/package.json
// module id = 437
// module chunks = 0